import { defineComponent, onMounted, onUnmounted, watch } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import SearchDropdown from '@/presentation/components/rights/rights-search/search-dropdown/search-dropdown.vue';
import SearchInputCode from '@/presentation/components/rights/rights-search/search-input.code';

export default defineComponent({
	components: {
		SearchDropdown,
		LoadingWrapper
	},
	setup: () => {
		const code = new SearchInputCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		watch(code.rightsUsersAsString, code.resetDropdown.bind(code));

		return {
			isLoading: code.isLoading,
			searchResultsAsString: code.searchResultsAsString,
			rightsUsersAsString: code.rightsUsersAsString,
			searchWrapper: code.searchWrapper,
			searchTerm: code.searchTerm,
			searchInput: code.searchInput,
			searchResults: code.searchResults,
			showSpinner: code.showSpinner,
			showDropdown: code.showDropdown,
			setSearchTerm: code.setSearchTerm.bind(code),
			revealDropdown: code.revealDropdown.bind(code)
		};
	}
});
